import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockKeyholeIcon, EyeOffIcon, UsersIcon } from 'lucide-react';
const trustSignals = [{
  icon: ShieldCheckIcon,
  title: "You're in control",
  description: 'You decide how and when to settle up, your own way.'
}, {
  icon: LockKeyholeIcon,
  title: 'Details shared on your terms',
  description: 'Save your bank details once and share them when you settle.'
}, {
  icon: EyeOffIcon,
  title: 'Private by design',
  description: 'Your kitties and their spends stay between the group.'
}, {
  icon: UsersIcon,
  title: 'You choose who joins',
  description: 'Admins approve join requests and manage every member.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: 'easeOut'
    }
  }
};
export function TrustSecurity() {
  return <section className="py-24 lg:py-32 bg-gray-950 text-white relative overflow-hidden" data-id="element-241" data-mp="3vndmmap1lrt5">
      {/* Subtle glow */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-242" data-mp="4jp0x0d60aul">
        <div className="absolute bottom-0 right-1/4 w-[600px] h-[400px] bg-kitty-yellow/[0.04] rounded-full blur-3xl" data-id="element-243" data-mp="3moa2r4i1x8dl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244" data-mp="3rnmspy47yvke">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-2xl mx-auto mb-16 lg:mb-20" data-id="element-245" data-mp="j6rw30e0m7er">
          <div className="inline-flex items-center gap-2 bg-white/[0.06] border border-white/[0.1] rounded-full px-4 py-1.5 mb-6" data-id="element-246" data-mp="efiacavl7o85">
            <ShieldCheckIcon className="w-4 h-4 text-kitty-yellow" data-id="element-247" data-mp="124bbclr2gm9m" />
            <span className="text-sm font-medium text-gray-300" data-id="element-248" data-mp="16wujv4awcr7k">
              Security & Trust
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight mb-5" data-id="element-249" data-mp="1gs2y8ljfmjr6">
            You stay in control of{' '}
            <span className="text-kitty-yellow" data-id="element-250" data-mp="16uezzlmmau49">your money.</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-xl mx-auto leading-relaxed" data-id="element-251" data-mp="16whzqxdko1m6">
            KittyPot keeps your group expenses clear and lets everyone settle up directly, person to person, your own way.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-id="element-252" data-mp="t2gxvurbpyhl">
          {trustSignals.map(item => <motion.div key={item.title} variants={itemVariants} className="rounded-2xl bg-white/[0.04] border border-white/[0.08] p-6 lg:p-8 text-center flex flex-col items-center" data-id="element-253" data-mp="j6noulctcn4k">
              <div className="w-12 h-12 rounded-2xl bg-kitty-yellow/10 flex items-center justify-center mb-5" data-id="element-254" data-mp="a5fqk3aarmah">
                <item.icon className="w-6 h-6 text-kitty-yellow" data-id="element-255" data-mp="2lqyik0jkfi9p" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-256" data-mp="2prs0mdabu2uo">
                {item.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" data-id="element-257" data-mp="2uszb4k3utg51">
                {item.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}